// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JN_s","left":"styles_left__3KOQx","desktopActions":"styles_desktopActions__2IzXd","title":"styles_title__Z9bSn"};